import { render, staticRenderFns } from "./Dzfp.vue?vue&type=template&id=d0bdf5fc&scoped=true"
import script from "./Dzfp.vue?vue&type=script&lang=js"
export * from "./Dzfp.vue?vue&type=script&lang=js"
import style0 from "./Dzfp.vue?vue&type=style&index=0&id=d0bdf5fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bdf5fc",
  null
  
)

export default component.exports